import sassyIcon from '../assets/sassy-app-icon.svg';
import tamboIcon from '../assets/tambo-app-icon.png';
import veriplusIcon from '../assets/veriplus-app-icon.svg';
import type { ProductId } from './products';

/**
 * Each product's app icon, as it appears on a phone's home screen.
 *
 * - VeriPlus: `veriplus-manufacturer-portal/brand/veriplus-app-icon-primary.svg`, byte for byte.
 * - Tambo: `tambo_website/public/icon-512.png`, the store icon, byte for byte.
 * - Sassy: `sassy-app-icon.svg`, drawn for this site; Sassy has no published icon yet.
 *
 * Do not redraw the first two. Refresh them from their repos.
 */
export const appIcons: Record<ProductId, string> = {
  veriplus: veriplusIcon,
  tambo: tamboIcon,
  sassy: sassyIcon,
};
